import { GAME_STATUS, UI_TEXT } from './utils/constants.js';
import './LadderControls.css';

/**
 * LadderControls - Game control buttons (start / login)
 */
export default function LadderControls({
  state,
  language = 'ko',
  hasToken = false,
  canPlay = true,
  isLoadingStatus = false,
  isStartingGame = false,
  loginToPlay,
  campaignName,
  onLogin,
  onStartGame,
}) {
  const text = UI_TEXT[language] || UI_TEXT.ko;
  const isLoginMode = !hasToken;

  const handleStartGame = () => {
    if (isLoginMode) {
      onLogin?.();
      return;
    }

    if (isLoadingStatus || isStartingGame || !canPlay) return;

    if (state.selectedStartIndex !== null && state.status === GAME_STATUS.SELECTING) {
      onStartGame?.();
    }
  };

  const getButtonLabel = () => {
    if (isLoginMode) {
      return loginToPlay || text.loginToPlay;
    }
    if (isLoadingStatus) {
      return text.loadingStatus;
    }
    if (isStartingGame) {
      return text.starting;
    }
    if (!canPlay) {
      return text.alreadyPlayed;
    }
    return text.start;
  };

  const isDisabled =
    isLoadingStatus ||
    isStartingGame ||
    (hasToken && !canPlay) ||
    (hasToken && canPlay && state.selectedStartIndex === null);

  return (
    <div className="ladder-controls ladder-controls--overlay">
      {state.status === GAME_STATUS.SELECTING && (
        <button
          className={`ladder-controls__start-button${isLoginMode ? ' ladder-controls__start-button--login' : ''}`}
          onClick={handleStartGame}
          disabled={isDisabled && !isLoginMode}
          type="button"
          data-amp-event={campaignName}
          data-amp-section="ladder_start"
          data-amp-title={isLoginMode ? 'ladder_login' : 'ladder_start'}
          data-track-event={campaignName}
          data-track-category="ladder_start"
          data-track-label={isLoginMode ? 'ladder_login' : 'ladder_start'}
        >
          {getButtonLabel()}
        </button>
      )}
    </div>
  );
}